module.exports = __webpack_public_path__ + "static/adeyemo-b6490d6d94f64da36e878c4e1470fa8f.png";